window.addEventListener('DOMContentLoaded', () => {

	const sliderDelay    = 2500;
	const sliderDuration = 7500;

	const initSponsorFade = (element, delay) => {
		const loadImg = (slide) => {
			const img = slide.querySelector('img');
			if (img.dataset.src) {
				img.src = img.dataset.src;
				img.dataset.src = '';
			}
		};

		const nextSlide = () => {
			const currentSlide = element.querySelector('.sponsor--active');
			const nextSlide = currentSlide.nextElementSibling ? currentSlide.nextElementSibling : currentSlide.parentElement.firstElementChild;

			loadImg(nextSlide);

			currentSlide.classList.remove('sponsor--active');
			nextSlide.classList.add('sponsor--active');
		};

		const slides = element.querySelectorAll('.sponsor');

		if (slides.length <= 1) {
			return;
		}

		slides[0].classList.add('sponsor--active');
		loadImg(slides[0]);

		setTimeout(() => {
			nextSlide();
			setInterval(nextSlide, sliderDuration);
		}, delay);
	};

	[].slice.call(document.querySelectorAll('[data-sponsor-list]')).forEach((fader, index) => {
		initSponsorFade(fader, sliderDelay*index);
	});

});